import { render, staticRenderFns } from "./SelectGoalSetDialog.vue?vue&type=template&id=b5ae4b22"
import script from "./SelectGoalSetDialog.ts?vue&type=script&lang=ts&external"
export * from "./SelectGoalSetDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectGoalSetDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports